import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'JOB_UPDATE',
    smsDelete : 'JOB_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        applicant: [],
        job: [],
        jobDetail: {},

        submitSuccess: false,
        applicantLoading: false,
        applicantError: false,
        jobLoading: false,
        jobError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_APPLICANT(state, results) {
            state.applicant = results;
        },

        APPLICANT_LOADING (state, loading) {
            state.applicantLoading = loading;
        },

        APPLICANT_ERROR (state, hasError) {
            state.applicantError = hasError;
        },

        SET_JOB(state, results) {
            state.job = results;
        },

        SET_JOB_DETAIL(state, result) {
            state.jobDetail = result;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        JOB_LOADING (state, loading) {
            state.jobLoading = loading;
        },

        JOB_ERROR (state, hasError) {
            state.jobError = hasError;
        }
    },

    actions: {
        // Applicant 
        // async addApplicant ({commit, dispatch}, payload) {
        //     commit('APPLICANT_LOADING', true);
        //     commit('APPLICANT_ERROR', false);

        //     let config = {
        //         headers: {
        //             Authorization: "Bearer " + localStorage.getItem("access_token")
        //         }
        //     };

        //     try {
        //         let response = await axios.post(V1API.create_applicant, payload.applicant, config).then(result=>{
        //             let data = result.data
        //             return data
        //         });

        //         commit('SUBMIT_SUCCESS', true);
        //         dispatch ('fetchApplicant')
        //         return response

        //     } catch (e) {
        //         commit('APPLICANT_ERROR', true);
        //     } finally {
        //         commit('APPLICANT_LOADING', false);
        //     }
        // },

        async fetchApplicant ({ commit }) {
            commit('APPLICANT_LOADING', true);
            commit('APPLICANT_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.applicant_list, config);
                let response = result.data.data
                commit('SET_APPLICANT', response);
                return result
            } catch(error) {
                commit('APPLICANT_ERROR', true);
            } finally {
                commit('APPLICANT_LOADING', false);
            }
        },

        async deleteApplicant({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.delete_applicant + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchApplicant')
            return response
        },

        // Job
        async addJob ({commit, dispatch}, payload) {
            commit('JOB_LOADING', true);
            commit('JOB_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.post(V1API.create_job, payload.job, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchJob')
                return response

            } catch (e) {
                commit('JOB_ERROR', true);
            } finally {
                commit('JOB_LOADING', false);
            }
        },

        async fetchJob ({ commit }) {
            commit('JOB_LOADING', true);
            commit('JOB_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.job_list, config);
                let response = result.data.data
                commit('SET_JOB', response);
                return result
            } catch(error) {
                commit('JOB_ERROR', true);
            } finally {
                commit('JOB_LOADING', false);
            }
        },

        async fetchJobDetail ({ commit }, payload) {
            commit('JOB_LOADING', true);
            commit('JOB_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.job_detail + payload, config);
                let response = result.data.data
                commit('SET_JOB_DETAIL', response);
                return result
            } catch(error) {
                commit('JOB_ERROR', true);
            } finally {
                commit('JOB_LOADING', false);
            }
        },

        async updateJob ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.patch(V1API.update_job + payload.id, payload.job, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchJobDetail', payload.id)
                return response

            } catch (e) {
                commit('JOB_ERROR', true);
            } finally {
                commit('JOB_LOADING', false);
            }
        },

        async deleteJob({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.delete_job + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchJob')
            return response
        },

        async toggleOpenedJob ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let response = await axios.get(V1API.toggle_job_open + payload.id, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchJob')
                return response

            } catch (e) {

            } finally {

            }
        }
    },

    getters: {}
}
